import { useLocation } from 'react-router-dom';

export default function ResetPassword() {
  const { search } = useLocation();

  return (
    <iframe
      src={`/page/resetpassword.html${search}`}
      title="Forgot Password"
      style={{
        width: "100%",
        height: "100vh",
        border: "none",
        background: "#FDF6EF"
      }}
    />
  );
}
